<template>
  <g fill="none" fill-rule="evenodd">
    <circle fill="#58C783" cx="10" cy="10" r="5" />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "LiveIcon",
});
</script>
